<template>
  <div class="live" :style="{ right: right + 'px' }" v-if="show && data.length">
    <div class="live-container">
      <div class="live-list">
        <div
          class="live-item"
          @click="toLink(item.link)"
          v-for="(item, index) in data"
          :key="index"
        >
          <p class="time">{{ formatDate(item.courseStartTime) }}</p>
          <div class="info">
            <img :src="item.image" alt="" />
            <p class="name">{{ item.courseName }}</p>
            <span> <i></i> 直播中…</span>
            <!-- <span
              class="gray"
              v-else-if="new Date().getTime() < item.courseStartTime"
              >未开始</span
            >
            <span
              class="gray"
              v-else-if="new Date().getTime() > item.courseEndTime"
              >已结束</span
            > -->
          </div>
        </div>
      </div>
    </div>
    <div class="live-close" @click="show = false">&times;</div>
  </div>
</template>

<script>
import $ from '../../views/mca/mcaStatic/js/jquery.min.js'
export default {
  data() {
    return {
      show: true,
      data: [],
      right: 0
    }
  },
  created() {
    $.get('/api/ks/livecourse/list', (res) => {
      if (res.code === 200 && res.data && res.data.length) {
        this.data = res.data.filter(
          (item) =>
            new Date().getTime() >= item.courseStartTime &&
            new Date().getTime() <= item.courseEndTime
        )
      }
    })
  },
  mounted() {
    if (window.innerWidth > 2560) {
      this.right = (window.innerWidth - 2560) / 2
    }
  },
  methods: {
    toLink(link) {
      window.open(link)
    },
    formatDate(date) {
      return new Date(date + 8 * 3600 * 1000)
        .toJSON()
        .substr(0, 19)
        .replace('T', ' ')
        .substr(11, 5)
    }
  }
}
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .live {
    // display: none;
  }
}
.live {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  z-index: 99;
  .live-container {
    width: 324px;
    height: 472px;
    background: url('~@/assets/live-bg.png');
  }
  .live-close {
    font-size: 32px;
    position: absolute;
    right: 24px;
    top: 16px;
    cursor: pointer;
    background: #333;
    color: #c7c7c7;
    height: 24px;
    line-height: 24px;
  }
  .live-list {
    position: relative;
    left: 18px;
    top: 138px;
    width: 275px;
    height: 292px;
    overflow: auto;
    padding-right: 20px;
    padding-left: 40px;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #295d9f;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #56cefd;
      border-radius: 4px;
    }
  }
  .live-item {
    text-align: left;
    cursor: pointer;
    position: relative;
    margin-bottom: 7px;
    &::after {
      content: '';
      display: block;
      position: absolute;
      width: 12px;
      height: 12px;
      background-color: #fff;
      border-radius: 50%;
      left: -33px;
      top: 10px;
    }
    .time {
      font-size: 24px;
      font-weight: 500;
      font-style: italic;
      color: #fff;
    }
    .info {
      border-radius: 12px;
      background: #fff;
      display: flex;
      height: 76px;
      position: relative;
      img {
        position: absolute;
        top: -10px;
        width: 64px;
        left: 10px;
      }
      .name {
        margin-top: 18px;
        flex-grow: 1;
        padding-left: 84px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        word-break: break-all;
        -webkit-line-clamp: 2;
        line-height: 18px;
        height: 36px;
      }
      span {
        position: absolute;
        bottom: 0;
        background: #b7418b;
        color: #fff;
        font-size: 12px;
        right: 0;
        padding: 0 4px;
        border-bottom-right-radius: 6px;
        &.gray {
          background: #ccc;
        }
        i {
          display: inline-block;
          width: 9px;
          height: 8px;
          background: url('~@/assets/live-run.png');
          background-size: contain;
        }
      }
    }
  }
}
</style>
